<template>

    <b-card>

        <b-row>
            <b-col  cols="10" sm="10" md="10" xl="10" lg="10">

                    <h4 class="font-weight-bolder" style="text-align: left !important;    margin: 0;">
                        <feather-icon
                                    icon="ListIcon"
                                    size="21"
                                    class="color_icon"
                                    style="margin-right: 10px;"
                                    />Listado de suscripciones
                            </h4>

                          
           
                    </b-col>

                    <b-col  cols="2" sm="2" md="2" xl="2" lg="2" style="    text-align: right;">
                    <b-skeleton v-if="loading" width="100%"  height="20px"></b-skeleton>
                    <p v-else style="cursor:pointer;    margin: 0;" @click="refresh()" > 
                                                                <feather-icon
                                                                icon="RefreshCcwIcon"
                                                                size="16"
                                                                style="margin-right:5px"
                                                                />  </p>
    
                    
                    </b-col>
        </b-row>

        <b-row v-if="loading">
          <b-col  cols="4" sm="4" md="4" xl="4" lg="4">
              
              
            </b-col>
            
            <b-col  cols="4" sm="4" md="4" xl="4" lg="4">
            
            <b-skeleton width="100%"  height="30px"></b-skeleton>
            
            </b-col>
            
            <b-col  cols="4" sm="4" md="4" xl="4" lg="4">
            
            
            </b-col>
            
            <b-col  cols="3" sm="3" md="3" xl="3" lg="3">
            
            
                </b-col>
            
                <b-col  cols="6" sm="6" md="6" xl="6" lg="6">
            
                <b-skeleton width="100%"  height="30px"></b-skeleton>
            
                </b-col>
            
                <b-col  cols="3" sm="3" md="3" xl="3" lg="3">
            
            
                </b-col>
            
            <b-col  cols="12" sm="12" md="12" xl="12" lg="12" style="margin-bottom:10px">
            
            
            
            
                              <b-skeleton-table
                          :rows="2"
                          :columns="columnas"
                          :table-props="{ bordered: true, striped: true }"
                        ></b-skeleton-table>
            
            </b-col>
            
            <b-col  cols="3" sm="3" md="3" xl="3" lg="3">
            
            
            </b-col>
            
            <b-col  cols="6" sm="6" md="6" xl="6" lg="6">
            
            <b-skeleton width="100%"  height="30px"></b-skeleton>
            
            </b-col>
            
            <b-col  cols="3" sm="3" md="3" xl="3" lg="3">
            
            
            </b-col>
            
            <b-col  cols="3" sm="3" md="3" xl="3" lg="3">
            
            
            </b-col>
            
            <b-col  cols="2" sm="2" md="2" xl="2" lg="2">
            <b-skeleton width="100%"  height="30px"></b-skeleton>
            
            
            </b-col>
            
            <b-col  cols="2" sm="2" md="2" xl="2" lg="2" align="center">
            <b-skeleton width="30px" type="avatar"   height="30px"></b-skeleton>
            
            
            </b-col>
            
            <b-col  cols="2" sm="2" md="2" xl="2" lg="2">
            <b-skeleton width="100%"  height="30px"></b-skeleton>
            
            
            </b-col>
            
            
            <b-col  cols="3" sm="3" md="3" xl="3" lg="3">
            
            
            </b-col>
        </b-row>


        <b-row v-else-if="code200">
   
    
    <b-col  cols="12" sm="12" md="12" xl="12" lg="12" style="  overflow: auto;padding: 0px; margin-top:15px">
    
      <table class="table tablesorter"  id="datatableProductos" >
                                  <thead class="thead-light">
                                    <tr>
                                      <th>Imagen</th>
                                      
                                      <th data-priority="1">Titulo</th>
                                      <th>Estado</th>
                                      <th data-priority="2" >Acción</th>
                                     
                                    </tr>
                                  </thead>
                                  <tbody>
    
    
                                    <tr v-for="producto in productos" :key="producto.id">
                                      <td> <b-img-lazy style="width: 100% !important; " v-bind="mainProps" :src="producto.urlImagen" :alt="producto.title"></b-img-lazy></td>
                                     <td>     
                                      
                                      <read-more more-str="Más información" :text="producto.title" link="#" less-str="Menos información" :max-chars="50"></read-more>

                                    </td>
                                     
                                     <td v-if="producto.aprobado === 'Aprobado'">
                                     <b-badge variant="success">
                                      Aprobado
                                      </b-badge>
                                  
                                  </td>
                                  <td v-else-if="producto.aprobado === 'En Revision'">

                                     <b-badge variant="warning">
                                        En Revisión
                                      </b-badge>
                                   
                                    
                                    </td>

                                   
                                       <td v-else>

                                     <b-badge variant="danger">
                                        Rechazado
                                      </b-badge>
                                   
                                    
                                    </td>
                             
                                     <td> 
                                      <b-dropdown  dropleft variant="light" size="sm"  no-caret>
                                              <template  #button-content>

                                              <feather-icon
                                                icon="MoreVerticalIcon"
                                                size="25"
                                                class="MoreVerticalIcon"
                                                />
                                                


                                              </template>

                                              <b-row>
                                                <b-col cols="12" sm="12" md="12" lg="12" xl="12">

                                                  <p style="margin:0px;    color: black; font-weight: bold; font-size:12px"> <feather-icon
                                                  icon="LinkIcon"
                                                  size="12"
                                                  style="margin-right: 5px;"

                                                  /> Comparte tu link de venta</p>
                                                  

                                                  <b-input-group >
    
                                                  <b-form-input
                                                  v-model="producto.url"
                                                  
                                                  
                                                      readonly>
                                                      
                                                      </b-form-input>

                                                  <b-input-group-append>
                                                      <b-button
                              
                                                      variant="outline-primary"
                                                      >

                                                      <feather-icon
                                                  icon="CopyIcon"
                                                  size="15"

                                                  /> 
                                                      </b-button>
                                                  </b-input-group-append>
                                                  </b-input-group>
                                                  <hr style="margin:10px">
                                                </b-col>
                                              </b-row>
                                         
                                              <b-dropdown-item @click="editarInformacion(producto.aprobado)">
                                                <feather-icon
                                                icon="EditIcon"
                                                size="15"
                                                style="margin-right: 10px;"
                                                />
                                              
                                                Editar información general
                                              </b-dropdown-item>

                                              <b-dropdown-item @click="editarDescripcion(producto.aprobado)">
                                                <feather-icon
                                                icon="EditIcon"
                                                size="15"
                                                style="margin-right: 10px;"
                                                />
                                              
                                                Editar descripción
                                              </b-dropdown-item>

                                              
                                              <b-dropdown-item @click="editarImagen(producto.aprobado)">
                                                <feather-icon
                                                icon="ImageIcon"
                                                size="15"
                                                style="margin-right: 10px;"
                                                />
                                              
                                                Editar imágenes
                                              </b-dropdown-item>

                                              <b-dropdown-item @click="deleteProducto(producto.id)">
                                                <feather-icon
                                                icon="TrashIcon"
                                                size="15"
                                                style="margin-right: 10px;"
                                                
                                                />
                                              
                                                Eliminar producto
                                              </b-dropdown-item>

                                            

                                            

                                            </b-dropdown>
                                          
                                          </td>
                                   
                              
    
                                    </tr>
                                  </tbody>
                                </table>
    
    
     </b-col>
    
    
     
    
     </b-row>
    
     <b-row v-else-if="empty">
    
    
    
     <b-col  align="center" cols="12" sm="12" md="12" xl="12" lg="12" style="margin-top:15px" >
      <feather-icon
              icon="StarIcon"
              size="55"
              class="color_icon"
            />                             
    
                             <p style="margin-top:15px">
                            No se encontraron suscripciones registrados
                          </p>
    
                  </b-col>
    

    </b-row>

   

    </b-card>
      
      </template>
      
      <script>
      import {
        BButton, BRow, VBPopover, BCol, BCard, BAvatar, BSkeleton, BSkeletonTable, BImgLazy, BBadge, BDropdown, BDropdownItem,BInputGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend, BFormGroup, 
      } from 'bootstrap-vue'
      
      import "jquery/dist/jquery.min.js";
    
    import $ from "jquery";
    import 'datatables.net-responsive-dt/css/responsive.dataTables.min.css'
    import 'datatables.net-responsive-dt/js/responsive.dataTables.min.js'
      
      export default {
        components: {
          BSkeleton,
          BDropdown, BDropdownItem,
            BAvatar,
            BBadge,
          BButton,
          BImgLazy,
          BRow,
          BCol,
          BCard,
          BSkeletonTable,
          BInputGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend, BFormGroup, 
        },
        directives: {
          'b-popover': VBPopover,
        },
        props: ['userId', 'tokenAuth', 'idLocal'],
        data() {
      
          const mq = window.matchMedia( "(min-width: 990px)" );
            let columnas=6;
    
            if (!mq.matches) {
    
              columnas =3;
              }
          return {
            code200: false,
          loading: true,
           empty:false,
           columnas:columnas,
           productos:[],
           mainProps: {
                      center: true,
                      fluidGrow: true,
                      blank: true,
                      blankColor: '#bbb',
                      width: 600,
                      height: 400,
                      class: 'my-5'
                    }
          }
        },
        computed: {
      
        },
        watch: {
      
        },
        mounted() {
          this.loadTable();
    
    
        },
        methods: {

          onCopy(copy) {
            navigator.clipboard.writeText(copy);

              this.$toast.success('Texto copiado!', {
                position: 'top-right',
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: false,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.4,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: true,
                rtl: false,
              })
            },
            onError() {
              this.$toast.error('Falló en copiar el texto', {
                position: 'top-right',
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: false,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.4,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: true,
                rtl: false,
              })
            },


            editarInformacion(estado){

              if(estado === "En Revision"){

                this.$toast.error('Su producto se encuentra en revisión por tal motivo, la edición se encuentra inhabilitado. Espere hasta que aprueben o rechazen su solicitud', {
                position: 'top-right',
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: false,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.4,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: true,
                rtl: false,
              })

              }else{

              }

            }, editarDescripcion(estado){

            if(estado === "En Revision"){

              this.$toast.error('Su producto se encuentra en revisión por tal motivo, la edición se encuentra inhabilitado. Espere hasta que aprueben o rechazen su solicitud', {
              position: 'top-right',
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: false,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.4,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: true,
              rtl: false,
            })

            }else{

            }

            }, editarImagen(estado){

            if(estado === "En Revision"){

              this.$toast.error('Su producto se encuentra en revisión por tal motivo, la edición se encuentra inhabilitado. Espere hasta que aprueben o rechazen su solicitud', {
              position: 'top-right',
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: false,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.4,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: true,
              rtl: false,
            })

            }else{

            }

            },
            deleteProducto(id){
    

                                  
              this.$swal({
              title: "¿Seguro que deseas eliminar este producto?",
              input: 'password',
              inputPlaceholder: "Ingrese su código PIN",
              inputAttributes: {
                autocapitalize: 'off',
                  maxlength: 6,
              },
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: "Eliminar",
              cancelButtonText: 'Cancelar',
              customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-secondary ml-1',
              },
              buttonsStyling: false,
              showLoaderOnConfirm: true,
              preConfirm: (pin) => {

                  if (pin != "") {

                      const data_json = { userId: this.userId,pin:pin, id:id}
                          const data_string = JSON.stringify(data_json)
              
                      
              
                          const dataEncripted = this.$encryptBackoffice.encrypt(data_string);

                          return this.$https.post('/locals/deleteProducto/', { tokenAuth: this.tokenAuth, data: dataEncripted }).then(response => response.data).catch(error => {
                              this.$swal.showValidationMessage(
                              error,
                              )
                          })


                  } else {
                      this.$swal.showValidationMessage('El código PIN es obligatorio')   
              }

              },
              allowOutsideClick: () => !this.$swal.isLoading(),
          }).then(result => {

              this.$swal.close()

              if(result.isConfirmed){



              
              if (result.value.code == 200) {

                  this.$eventBus.$emit('reiniciarListadoSuscripciones')

                      
                  
                          this.$toast.success(result.value.message, {
                          position: 'top-right',
                          timeout: 3010,
                          closeOnClick: true,
                          pauseOnFocusLoss: false,
                          pauseOnHover: true,
                          draggable: true,
                          draggablePercent: 0.4,
                          showCloseButtonOnHover: false,
                          hideProgressBar: true,
                          closeButton: 'button',
                          icon: true,
                          rtl: false,
                          })



                      } else {

                         

                          this.$toast.error(result.value.message, {
                          position: 'top-right',
                          timeout: 3010,
                          closeOnClick: true,
                          pauseOnFocusLoss: false,
                          pauseOnHover: true,
                          draggable: true,
                          draggablePercent: 0.4,
                          showCloseButtonOnHover: false,
                          hideProgressBar: true,
                          closeButton: 'button',
                          icon: true,
                          rtl: false,
                          })

                          if (result.data.code == 401) {
                          
                          localStorage.removeItem('userData')


                          

                          // Redirect to login page
                          this.$router.push({ name: 'auth-login' })
                          }else{

                            if (result.data.code == 404) {
                              this.$eventBus.$emit('reiniciarListadoSuscripciones')
                            }
                           

                          }
                      }

              }
              




          })




          },
  
          refresh() {
          this.$eventBus.$emit('reiniciarListadoSuscripciones')
        }, loadTable(){
          
            const data_json = { userId: this.userId, idLocal: this.idLocal, type: "Suscripcion" }
                    
          this.$https.post('/locals/getProductos/', { tokenAuth: this.tokenAuth, data: data_json }).then(response => {
          
             this.loading=false;

                          if(response.data["code"] == 200){
                          
                         
                    
                           
    
                            this.productos= response.data["productos"];
     
                     
                                      setTimeout(() => {
                                        $("#datatableProductos").DataTable({
                                          responsive: true,
                                          "ordering": false,
                                          lengthMenu: [
                                            [5,10, 25, 50, -1],
                                            [5,10, 25, 50, "All"],
                                          ],
                                          pageLength: 5, 
                                             "language": {
                                                  "search": "Buscar:",
                                                  "sInfo":      "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                                                    "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                                                  "searchPlaceholder": "Ingrese algún dato",
                                                  "zeroRecords": "Lo sentimos, no se encontraron resultados",
                                                  "processing": "Buscando. Espere por favor...",
                                                  "sLengthMenu":     "Mostrar _MENU_ registros",
                                                  "oPaginate": {
                                                          "sFirst":    "Primero",
                                                          "sLast":     "Último",
                                                          "sNext":     "Siguiente",
                                                          "sPrevious": "Anterior"
                                                      },
    
                                                  }
                                        });
                                      });
    
                                         this.code200=true;
    
                         
      
                              
                            }else{
    
               
                                
    
    
                                      if (response.data.code == 401) {
    
                                        this.$toast.error(response.data.message, {
                                  position: 'top-right',
                                  timeout: 3010,
                                  closeOnClick: true,
                                  pauseOnFocusLoss: false,
                                  pauseOnHover: true,
                                  draggable: true,
                                  draggablePercent: 0.4,
                                  showCloseButtonOnHover: false,
                                  hideProgressBar: true,
                                  closeButton: 'button',
                                  icon: true,
                                  rtl: false,
                                })
    
    
                                        
                                        localStorage.removeItem('userData')
    
    
    
                                        
                                        
    
               
    
                                        
                                        
    
                                        // Redirect to login page
                                        this.$router.push({ name: 'auth-login' })
                                      } else {
    
                                         if (response.data.code == 404) {
    
                                          this.$eventBus.$emit('activeHome');
                                           this.$eventBus.$emit('reiniciarAllNegocio');
    
                                        
    
                                        }else{

                                            if (response.data.code == 405) {
                                                this.empty=true;
                                            }else{
                                                this.loadTable(); 
                                            }

                                            
    
                                        }
                                      
    
    
                                      }
    
                            }
                     }).catch((error) => {
    
                              this.loadTable();
    
                         
                     });
        }
         
         
      
        },
      }
      </script>
      
      <style lang="scss">
      
      
      
      </style>
      